import React from 'react';
import { EventPriceTier, nextPriceChangeLabel, priceTierRows, priceTierUntilLabel } from '@radevents/shared';

/**
 * Preisstufen eines Events: je Stufe Bezeichnung und letzter Tag, die laufende hervorgehoben,
 * abgelaufene durchgestrichen. Darunter, wann es als Nächstes teurer wird. Beträge gibt es bewusst
 * nicht (V179). Ohne Stufen zeichnet die Komponente nichts.
 */
const PriceTierList: React.FC<{ tiers?: EventPriceTier[] | null; now?: Date }> = ({ tiers, now }) => {
  const rows = priceTierRows(tiers, now);
  if (rows.length === 0) return null;
  const change = nextPriceChangeLabel(tiers, now);
  return (
    <>
      <ul className="pt-list">
        {rows.map(({ tier, name, state }, i) => (
          <li key={i} className={`pt-row pt-row--${state}`}>
            <span className="pt-row-name">
              {name}
              {state === 'current' && <span className="pt-now">JETZT</span>}
            </span>
            <span className="pt-row-until">{priceTierUntilLabel(tier)}</span>
          </li>
        ))}
      </ul>
      {change && <p className="pt-change">{change}.</p>}
    </>
  );
};

export default PriceTierList;
